import { render, staticRenderFns } from "./PathView.vue?vue&type=template&id=5437f4fa&scoped=true&"
import script from "./PathView.vue?vue&type=script&lang=js&"
export * from "./PathView.vue?vue&type=script&lang=js&"
import style0 from "./PathView.vue?vue&type=style&index=0&id=5437f4fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5437f4fa",
  null
  
)

export default component.exports